import { Card } from "@fpsoftware/mvp";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { TbDeviceFloppy } from "react-icons/tb";
import { CompanyFeesPutBodySchema } from "shared";
import {
  useCompanyFees,
  useCompanyFeesActions,
} from "@/company/useCompanyFees";
import { Button } from "@/components/Button";
import { FeeListFields } from "@/components/form/FeeListFields";
import styles from "./CompanyFeesForm.module.css";

export function CompanyFeesForm() {
  const fees = useCompanyFees();
  const { updateFees } = useCompanyFeesActions();

  const { handleSubmit, formState, control } = useForm({
    resolver: zodResolver(CompanyFeesPutBodySchema),
    defaultValues: {
      fees: fees.map((fee) => ({ name: fee.name, amount: fee.amount })),
    },
  });

  const onSubmit = handleSubmit(updateFees);

  return (
    <Card>
      <form onSubmit={onSubmit}>
        <Card.Header>Company fees</Card.Header>
        <Card.Body>
          <FeeListFields control={control} name="fees" />
        </Card.Body>
        <Card.Footer>
          <div className={styles.actions}>
            <Button
              icon={TbDeviceFloppy}
              type="submit"
              loading={formState.isSubmitting}
            >
              Save
            </Button>
          </div>
        </Card.Footer>
      </form>
    </Card>
  );
}
